<template>
  <div class="module-block" :style="getVarStyle" :class="getClass">
    <template v-if="$store.getters.isStandAloneMode">
      <div v-if="checkShowMobileBackgroundImage" class="module-block__mobile-image" :style="mobileStyle" />
      <div v-if="checkShowBackgroundImage" class="module-block__image" :style="bgStyle" />
      <div v-if="isShowColor" class="module-block__color-bg" :style="getBgColorStyle" />
    </template>
    <div class="module-block__content">
      <slot />
    </div>
  </div>
</template>

<script>
import { getTextColor } from '~/utils';
import { computeBackgroundStyle, isShowColor, isShowBackgroundImage } from '~/site/model/helper'

export default {
  name: 'ModuleBlock',
  props: {
    bg: Object,
    mobileBg: Object,
    noPadding: {
      type: Boolean,
      default: false
    },
    maxContentWidth: {
      type: Number,
      default: 1280
    }
  },
  computed: {
    checkShowMobileBackgroundImage() {
      return isShowBackgroundImage(this.mobileBg) && this.$store.getters.isMobile
    },
    checkShowBackgroundImage() {
      return isShowBackgroundImage(this.bg) && !this.$store.getters.isMobile
    },
    mobileStyle() {
      return computeBackgroundStyle(this.mobileBg, {})
    },
    bgStyle() {
      return computeBackgroundStyle(this.bg, {})
    },
    isShowColor() {
      return isShowColor(this.bg)
    },
    getClass() {
      const result = []
      if (this.$store.getters.isMobile) {
        result.push('is-moble')
        this.mobileBg?.backgroundSize && result.push(this.mobileBg.backgroundSize)
      } else {
        this.bg?.backgroundSize && result.push(this.bg.backgroundSize)
      }
      this.bg?.noPadding && result.push('no-padding')
      return result
    },
    getBgColorStyle() {
      return {
        backgroundColor: getTextColor(this.bg).color
      }
    },
    getImageStyle() {
      return {
        backgroundImage: this.$store.getters.isMobile ? this.mobileBg.backgroundImage : this.bg.backgroundImage
      }
    },
    getVarStyle() {
      return {
        '--max-content-width': this.maxContentWidth + 'px'
      }
    }
  }
}
</script>

<style lang="less">
.module-block {
  padding: 30px;
  position: relative;
  margin: 0 auto;
  max-width: var(--max-content-width);
  --radius: 20px;

  &__color-bg,
  &__image,
  &__mobile-image {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 20px;
  }

  &__content {
    margin: 0 auto;
  }

  &.is-moble {
    padding: 10px 5px;
    border-radius: 10px;
  }

  &.no-padding {
    padding: 0 !important;
  }
}

.stand-alone-mode {
  .module-block {
    border-radius: var(--radius);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    position: relative;
  }
}
</style>
